import React, { useState } from 'react'

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Stack,
} from '@mui/material'
import { listFromCodes, listFromKV } from '../../Functions/ListItemGenerator'
import { useHoldingContext } from '../../Contexts/CurrentHolding'
import { useUserContext } from '../../Contexts/UserConfig'
import PageSection from '../../Constants&Theme/PageSection'
import { useGetKVCodeSet } from '../../APIs/Hooks/CodeSetHooks'
import { useNewSampleRun } from '../../APIs/Hooks/SampleRunHooks'
import { stackGap } from '../../Constants&Theme/Spacing'

function SampleCollect() {
  const { loginConfig, loadingConfig } = useUserContext()
  const { data: facilityData, isLoading: facilityLoading } = useGetKVCodeSet(
    'KV-SampleFacilities',
  )

  const { currentHolding } = useHoldingContext()

  const [fields, setFields] = useState({
    type: '100',
    vesselType: 'TRY',
    destination: 2,
    forOwner: '',
  })

  const sampleRunTypes = listFromCodes(
    loginConfig,
    'SampleRunTypeID',
    loadingConfig,
    '100',
  )
  const vesselTypes = listFromCodes(
    loginConfig,
    'VesselTypeID',
    loadingConfig,
    'TRY',
  )
  const facilities = listFromKV(facilityData, facilityLoading, 2)
  const owners = listFromCodes(loginConfig, 'KV-Owners', loadingConfig)

  const { mutate } = useNewSampleRun()
  function formChange(event: any) {
    setFields((f) => ({ ...f, [event.target.name]: event.target.value }))
  }

  return (
    <Box
      sx={{
        maxWidth: 'sm',
        width: 1,
      }}
    >
      <PageSection title={'Create Sample Run'}>
        <Stack
          gap={stackGap.col}
          width={1}
        >
          <FormControl fullWidth>
            <InputLabel>Type</InputLabel>
            <Select
              label="Type"
              name="type"
              value={fields.type}
              onChange={formChange}
            >
              {sampleRunTypes}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Collect In</InputLabel>
            <Select
              label="Collect In"
              name="vesselType"
              value={fields.vesselType}
              onChange={formChange}
            >
              {vesselTypes}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Destination</InputLabel>
            <Select
              label="Destination"
              name="destination"
              value={fields.destination}
              onChange={formChange}
            >
              {facilities}
            </Select>
            <FormHelperText>
              Applicable only for non DNA-Prep type collections
            </FormHelperText>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>For Owner</InputLabel>
            <Select
              label="For Owner"
              name="forOwner"
              value={fields.forOwner || ''}
              onChange={formChange}
            >
              {owners}
            </Select>
            <FormHelperText>
              Leave blank to automatically set to the Owner of the first scanned
              container
            </FormHelperText>
          </FormControl>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              aria-label={'Create Sample Run'}
              variant="contained"
              color="primary"
              onClick={() =>
                mutate({
                  holding_id: currentHolding.value,
                  owner_id: fields.forOwner,
                  run_type: fields.type,
                  destination: fields.destination,
                  vessel_type: fields.vesselType,
                })
              }
            >
              Create Sample Run
            </Button>
          </Box>
        </Stack>
      </PageSection>
    </Box>
  )
}

export default SampleCollect
